<template>
  <OnBoardingFrame :subtitle="$t('on_boarding.success_page.you_can_always_download_the_app')">
    <template #title>
      <i18n-t keypath="on_boarding.success_page.get_the_app" scope="global">
        <template #app><span class="ob-title__accent">{{ $t('on_boarding.success_page.hiiker_app') }}</span></template>
      </i18n-t>
    </template>

    <img
      class="ob-app-preview"
      src="../../../images/onboarding-app-preview.png"
      :alt="$t('on_boarding.success_page.hiiker_app_preview')"
      width="150"
    >

    <!-- Dynamic sign-in QR (desktop/tablet only — scanning the same phone's screen is pointless).
         Store badges cover the mobile case instead, since the QR already handles install + sign-in there. -->
    <div class="ob-qr-card d-none d-md-block">
      <MobileLoginQRInline />
    </div>

    <div class="ob-store-badges d-md-none">
      <a
        target="_blank"
        href="https://play.google.com/store/apps/details?id=com.waymarkedtrails.hiiker&hl=en_IE&gl=US"
      >
        <img src="../../../images/google-play-btn-white.png" :alt="$t('on_boarding.success_page.get_hiiker_on_google_play')">
      </a>
      <a
        target="_blank"
        href="https://apps.apple.com/ie/app/hiiker-hiking-trails/id1470810597"
      >
        <img src="../../../images/app-app-store-btn-white.png" :alt="$t('on_boarding.success_page.download_hiiker_on_the_app_store')">
      </a>
    </div>

    <!-- Way out for users who don't want to install the app right now.
         Without this CTA the page reads as "you must continue on mobile",
         which the modal isn't actually asking for. On the modal flow this
         hides the dialog; on the standalone /login page it redirects to
         the post-login destination (or homepage). -->
    <template #footer>
      <button type="button" class="ob-btn ob-btn-primary" @click="continueOnWebsite">
        {{ $t('on_boarding.success_page.continue_on_website') }}
      </button>
    </template>
  </OnBoardingFrame>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Modal } from 'bootstrap';
import MobileLoginQRInline from '../../mobile_login_qr/MobileLoginQRInline.vue';
import OnBoardingFrame from './OnBoardingFrame.vue';

export default defineComponent({
  name: 'OnBoardingSuccessPage',
  components: { OnBoardingFrame, MobileLoginQRInline },
  methods: {
    continueOnWebsite() {
      // Standalone /login page: there's no modal, so redirect to whatever the
      // user was trying to reach (or the homepage). Mirrors the post-login
      // routing in OnBoardingModule's setNextPostLoginPage().
      if (this.$store.state.onBoarding.standaloneMode) {
        const stored = sessionStorage.getItem('redirectAfterLogin');
        if (stored) {
          sessionStorage.removeItem('redirectAfterLogin');
          window.location.href = stored;
        } else {
          window.location.href = '/';
        }
        return;
      }

      // Modal flow: just close the dialog and let the user carry on with
      // whatever page they triggered the signup from.
      const element = document.getElementById('on-boarding-dialog');
      const modal = element ? Modal.getInstance(element) : null;
      modal?.hide();
    },
  },
});
</script>
